const getters = {
  sidebar: (state) => state.app.sidebar,
  size: (state) => state.app.size,
  progress: (state) => state.app.requestProgress,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  user: (state) => {
    return {
      userId: state.user.id,
      username: state.user.username,
      roles: state.user.roles,
      permissions: state.user.permissions,
      avatar: state.user.avatar,
      email: state.user.email,
      name: {
        first: state.user.firstName,
        last: state.user.lastName,
      },
    };
  },
  allRoutes: (state) => state.permission.allRoutes,
  generatedRoutes: (state) => state.permission.addedRoutes,
  routesGenerated: (state) => state.permission.routesGenerated,
};
export default getters;
